import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PeriodoReporteFiviI } from 'src/app/modelos/PeriodoReporteFivi';
import { PeriodoTrimestralesFiviDto } from 'src/app/modelos/PeriodosTrimestralesFivi';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { FuentesPuntajesDtoI } from 'src/app/modelos/FuentesPuntajesDto';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import { InforIndicadoresDtoI } from 'src/app/modelos/InformacionIndicadoresDto';
import { AnalisisService } from 'src/app/servicios/analisis/analisis.service';
import { IndicadoresService } from 'src/app/servicios/indicadores/indicadores.service';
declare var Plotly: any;

@Component({
  selector: 'app-indicadoresfivitrimestral',
  templateUrl: './indicadoresfivitrimestral.component.html',
  styleUrls: ['./indicadoresfivitrimestral.component.css']
})
export class IndicadoresfivitrimestralComponent implements OnInit {

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private analisisService:AnalisisService,
    private appService:AppServiceService,
    private indicadoresService: IndicadoresService
    ) { }

  //PeriodoSeleccionado: PeriodoTrimestralesFiviDto = new PeriodoTrimestralesFiviDto();
  ListaPeriodosConsultar:PeriodoTrimestralesFiviDto[];
  InformacionIndicadores : InforIndicadoresDtoI = new InforIndicadoresDtoI;
  TablaIndicadores : FuentesPuntajesDtoI[];

  @ViewChild('openmodalcargando') openmodalcargando: ElementRef;
  @ViewChild('closemodacargando') closemodacargando: ElementRef;

  aniosVigen: Number[];
  PeriodoSeleccionado : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  anioConsulta : Number = 0;
  consucutivoConsulta : Number = 0;
  stringBase64 : any = "";
  stringPdfBase64 : any = "";

  ngOnInit() {
    this.analisisService.consultarPeriodoActivoFIVI().subscribe(Result=>{
      this.anioConsulta = Number(Result.anio);
      this.PeriodoSeleccionado = Result;
      if(Number(Result.consecutivoPeriodo)>=1&&Number(Result.consecutivoPeriodo)<=3){
        this.anioConsulta = Number(this.anioConsulta) - 1;
        this.consucutivoConsulta = 4;
        this.ConsultarDatos1(this.consucutivoConsulta+"/"+this.anioConsulta);
      }
      if(Number(Result.consecutivoPeriodo)>=4&&Number(Result.consecutivoPeriodo)<=6){
        this.consucutivoConsulta = 1;
        this.ConsultarDatos1(this.consucutivoConsulta+"/"+this.anioConsulta);
      }
      if(Number(Result.consecutivoPeriodo)>=7&&Number(Result.consecutivoPeriodo)<=8){
        this.consucutivoConsulta = 2;
        this.ConsultarDatos1(this.consucutivoConsulta+"/"+this.anioConsulta);
      }
      if(Number(Result.consecutivoPeriodo)>=9&&Number(Result.consecutivoPeriodo)<=12){
        this.consucutivoConsulta = 3;
        this.ConsultarDatos1(this.consucutivoConsulta+"/"+this.anioConsulta);
      }
    });
    this.indicadoresService.CalendarioTrimestresFivi().subscribe(Result2=>{
      this.ListaPeriodosConsultar = Result2;
    });
    this.analisisService.getListaAniosVigenciaFivi().subscribe(respuesta0=>{
      this.aniosVigen = respuesta0;
    });
  }

  RegresarOperativo(){
    this.router.navigate(['indicadores']);
  }

  peridoPorAnioMes(){
    this.analisisService.periodoFiviPorAnioMes(this.anioConsulta,this.consucutivoConsulta).subscribe(respuesta2=>{
      this.PeriodoSeleccionado = respuesta2;
    });
  }

  ConsultarDatos1(periodo){
    this.indicadoresService.InformacionIndicadoresFivi(periodo).subscribe(Result1=>{
      if(Result1){
        this.InformacionIndicadores = Result1;
        this.stringBase64 = Result1.doc;
        this.stringPdfBase64 = Result1.pdf;
        this.TablaIndicadores = Result1.fuentesPunajes;
        var layout = {
          height: 400,
          width: 500,
          showlegend: false,
          modebardisplay: false
        };
        var layout1 = {
          height: 400,
          width: 500,
          showlegend: false
        };
        var options: any = {
          displayModeBar: false,
          staticPlot: true,
          responsive: true
        };
        var data1 = [{
          values: [(Result1.numeroTotalFtes-Result1.numeroFtesReportaron), Result1.numeroFtesReportaron],
          labels: ['Número fuentes no reportan', 'Número fuentes reportan'],
          type: 'pie',
          marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
        }];
        Plotly.newPlot('myPlotlyDiv1', data1, layout, options);
        //Plotly.newPlot('myPlotlyDiv1_2', data1, layout, options);
        var data2 = [{
          values: [(100-Result1.icif), Result1.icif],
          labels: [' ', '% ICIf'],
          type: 'pie',
          marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
        }];
        Plotly.newPlot('myPlotlyDiv2', data2, layout1,options);
        //Plotly.newPlot('myPlotlyDiv2_2', data2, layout1,options);
        var data3 = [{
          values: [(100 - Result1.icri), Result1.icri],
          labels: [' ', '% ICRI'],
          type: 'pie',
          marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
        }];
        Plotly.newPlot('myPlotlyDiv3', data3, layout1,options);
        //Plotly.newPlot('myPlotlyDiv3_2', data3, layout1,options);
        var data4 = [{
          values: [(100 - Result1.icg), Result1.icg],
          labels: [' ', '% ICG'],
          type: 'pie',
          marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
        }];
        Plotly.newPlot('myPlotlyDiv4', data4, layout1,options);
        //Plotly.newPlot('myPlotlyDiv4_2', data4, layout1,options);
      }
    });
  }

  CosultarDatos2(){
    this.indicadoresService.InformacionIndicadoresFivi(this.consucutivoConsulta+'/'+this.anioConsulta).subscribe(Result3=>{
        if(Result3){
          this.InformacionIndicadores = Result3;
          this.stringBase64 = Result3.doc;
          this.stringPdfBase64 = Result3.pdf;
          this.TablaIndicadores = Result3.fuentesPunajes;
          var layout = {
            height: 400,
            width: 500,
            showlegend: false,
            modebardisplay: false
          };
          var layout1 = {
            height: 400,
            width: 500,
            showlegend: false
          };
          var options: any = {
            displayModeBar: false,
            staticPlot: true,
            responsive: true
          };
          var data1 = [{
            values: [(Result3.numeroTotalFtes-Result3.numeroFtesReportaron), Result3.numeroFtesReportaron],
            labels: ['Número fuentes no reportan', 'Número fuentes reportan'],
            type: 'pie',
            marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
          }];
          Plotly.newPlot('myPlotlyDiv1', data1, layout, options);
          //Plotly.newPlot('myPlotlyDiv1_2', data1, layout, options);
          var data2 = [{
            values: [(100 - Result3.icif), Result3.icif],
            labels: [' ', '% ICIf'],
            type: 'pie',
            marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
          }];
          Plotly.newPlot('myPlotlyDiv2', data2, layout1,options);
          //Plotly.newPlot('myPlotlyDiv2_2', data2, layout1,options);
          var data3 = [{
            values: [(100 - Result3.icri), Result3.icri],
            labels: [' ', '% ICRI'],
            type: 'pie',
            marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
          }];
          Plotly.newPlot('myPlotlyDiv3', data3, layout1,options);
          //Plotly.newPlot('myPlotlyDiv3_2', data3, layout1,options);
          var data4 = [{
            values: [(100 - Result3.icg), Result3.icg],
            labels: [' ', '% ICG'],
            type: 'pie',
            marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
          }];
          Plotly.newPlot('myPlotlyDiv4', data4, layout1,options);
          //Plotly.newPlot('myPlotlyDiv4_2', data4, layout1,options);
        }
    });
  }

  descargarArchivoExcel() {
    if (this.stringBase64) {
      const blob = this.base64toBlob(this.stringBase64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'Indicadores periodo '+this.consucutivoConsulta+' '+this.anioConsulta+'.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error('No hay datos para descargar');
    }
  }

  descargarArchivoPDF() {
    if (this.stringPdfBase64) {
      const blob = this.base64toBlob(this.stringPdfBase64, 'application/pdf');
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'Indicadores periodo ' + this.consucutivoConsulta + ' ' + this.anioConsulta + '.pdf';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error('No hay datos para descargar');
    }
  }

  base64toBlob(base64Data: string, contentType: string): Blob {
    const sliceSize = 512;
    const byteCharacters = atob(base64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

}
